module.exports = __webpack_public_path__ + "media/en_gb_s1_Alen.2ef03b02.oga";